import { StateCreator } from 'zustand';
import { allSlices, roomSlice } from './interface';
import { virtualBackgrounds } from '@/utils/constants';

export const createRoomSlice: StateCreator<allSlices, [], [], roomSlice> = (set) => ({
  end: false,
  ended: false,
  generatePDF: false,
  noFollow: false,
  forcedDisconnect: false,
  error: false,
  roomId: null,
  userId: null,
  presenterId: null,
  recorderId: null,
  isRecorder: false,
  sidebar: null,
  attendees: [],
  attendeesMap: {},
  attendee: null,
  totalAttendees: 0,
  blockedStatus: { chat: false, audio: true, video: false, qna: false },
  referredBy: '',
  virtualBackground: virtualBackgrounds[0],
  setEnd: (data) =>
    set((state) => ({
      room: {
        ...state.room,
        end: data
      }
    })),
  setEnded: (data) =>
    set((state) => ({
      room: {
        ...state.room,
        ended: data
      }
    })),
  setSidebar: (data) =>
    set((state) => ({
      room: {
        ...state.room,
        sidebar: state.room.sidebar === data ? null : data
      }
    })),
  setVirtualBackground: (url) =>
    set((state) => ({
      room: {
        ...state.room,
        virtualBackground: url
      }
    })),
  setRoomData: (data) =>
    set((state) => ({
      room: {
        ...state.room,
        ...data
      }
    })),
  extendRoom: (time) =>
    set((state) => ({
      room: {
        ...state.room,
        endTime: (state.room?.endTime || 0) + time * 60 * 1000
      }
    })),
  extendedRoom: (time) =>
    set((state) => ({
      room: {
        ...state.room,
        endTime: time
      }
    })),
  setBlockedStatus: (data) =>
    set((state) => ({
      room: { ...state.room, blockedStatus: { ...state.room.blockedStatus, ...data } }
    })),
  addAttendee: (attendee) =>
    set((state) => ({
      room: {
        ...state.room,
        attendees: [...state.room.attendees, attendee],
        attendeesMap: { ...state.room.attendeesMap, [attendee.id]: attendee },
        totalAttendees: state.room.totalAttendees + 1
      }
    })),
  editAttendee: (attendee) =>
    set((state) => {
      let totalAttendees = state.room.totalAttendees;
      const attendees = JSON.parse(JSON.stringify(state.room.attendees));
      const attendeesMap = JSON.parse(JSON.stringify(state.room.attendeesMap));
      const attendeeIndex = state.room.attendees.findIndex((d) => d.id === attendee.id);

      if (attendeeIndex > -1) {
        if (
          typeof attendee.isConnected !== 'undefined' &&
          attendees[attendeeIndex].isConnected !== attendee.isConnected
        ) {
          totalAttendees = totalAttendees + 1 * (attendee.isConnected ? 1 : -1);
        }

        attendees[attendeeIndex] = { ...attendees[attendeeIndex], ...attendee };
        if (attendee.id) attendeesMap[attendee.id] = { ...attendees[attendeeIndex] };

        if (attendees[attendeeIndex].id === state.room.userId) {
          return {
            room: { ...state.room, attendees, attendeesMap, attendee: attendees[attendeeIndex] }
          };
        }

        return {
          room: { ...state.room, attendees, attendeesMap, totalAttendees }
        };
      }
      return state;
    })
});
export default createRoomSlice;
